(() => {
  const maxWaitTime = 6000;
  const intervalTime = 100;
  let elapsedTime = 0;
  
  const interval = setInterval(() => {
      const vatInput = document.querySelector(".bss-b2b-vat-input");
      
      if (vatInput) {
          document.querySelector(".cart__footer .cart__ctas").before(document.querySelector(".bss-b2b-tax-ex-wrapper"))
          document.querySelector(".bss-b2b-vat-input").value = document.querySelector("[data-vat]").getAttribute("data-vat")
          clearInterval(interval);
      }
  
      elapsedTime += intervalTime;
      if (elapsedTime >= maxWaitTime) {
          clearInterval(interval);
      }
  }, intervalTime);
 
})()